import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useEffect, useMemo } from 'react';
import { IdentityValidationWizard } from './components/flows/identity-validation-wizard';
import { MagicLinkWizardSessionManager } from './components/flows/magic-link-wizard-session-manager';
import { LoadingScreen } from './components/screens/loading';
import { applyFavicon } from './helpers/favicon';
import { useBrandingQuery } from './hooks/use-branding';
import { createAppTheme } from './theme';

export const App = () => {
  const isIdentityValidationFlow = window.location.pathname.startsWith('/validar/');
  const brandingQuery = useBrandingQuery();
  const branding = brandingQuery.data?.branding;

  const bootstrapping = brandingQuery.isInitialLoading;

  const appTheme = useMemo(
    () => createAppTheme(branding),
    [
      branding?.primaryColor,
      branding?.secondaryColor,
      branding?.primaryContrastColor,
      branding?.secondaryContrastColor,
      branding?.backgroundColor,
    ],
  );

  // Without branding, the icons and title templated per host by the CloudFront
  // lambda are already right, whitelabel hosts included, so they are kept.
  useEffect(() => {
    if (bootstrapping || !branding) return;
    applyFavicon(branding);
    document.title = document.title.replace(/^CUB - /, '');
  }, [bootstrapping, branding]);

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      {bootstrapping ? (
        // neutral greys: the tenant colours are not known yet, so branding the
        // bootstrap screen would mean flashing CUB blue at a whitelabeled tenant
        <LoadingScreen message="Carregando..." backgroundColor="grey.100" progressColor="grey.500" />
      ) : isIdentityValidationFlow ? (
        <IdentityValidationWizard />
      ) : (
        <MagicLinkWizardSessionManager />
      )}
    </ThemeProvider>
  );
};
